module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "basic-text-frame"
  }, [_c('p', {
    staticClass: "chapterheader",
    attrs: {
      "id": "toc_marker-2-6"
    }
  }, [_c('span', {
    staticClass: "chapterheader1"
  }, [_vm._v("Chapter 6")])])]), _vm._v(" "), _c('div', {
    staticClass: "basic-text-frame"
  }, [_c('p', {
    staticClass: "bodytext2"
  }, [_c('span', {
    staticClass: "dedication1"
  }, [_vm._v("By the end of the day, I marveled at my new windows, even though they needed a good washing. I decided to call Korine tomorrow to see if I could convince her to come back and help me. She had done such a fantastic job on the windows in the house when I moved in. I then crawled into bed with a book that I never opened before I fell asleep. I smiled at the thought of Holly coming to visit the next day.")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext2"
  }, [_c('span', {
    staticClass: "dedication1"
  }, [_vm._v("In the morning, I really expected to get a call from Holly saying she needed to cancel, but it seemed that all was well. After I’d had my coffee, I made the call to Korine. She listened intently before she gave me an answer.")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext2"
  }, [_c('span', {
    staticClass: "dedication1"
  }, [_vm._v("“Well, I do need some Christmas money, and if you promise not to leave me alone in the house, I’ll come.”")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext2"
  }, [_c('span', {
    staticClass: "dedication1"
  }, [_vm._v("“It’s a deal. How soon can you be here?”")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext2"
  }, [_c('span', {
    staticClass: "dedication1"
  }, [_vm._v("“Tomorrow, I suppose,” she said with hesitation.")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext2"
  }, [_c('span', {
    staticClass: "dedication1"
  }, [_vm._v("“That’s great! How about nine in the morning?”")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext2"
  }, [_c('span', {
    staticClass: "dedication1"
  }, [_vm._v("“I’ll be there.” ")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext2"
  }, [_c('span', {
    staticClass: "dedication1"
  }, [_vm._v("I hung up the phone feeling very relieved and excited. I had been pleased when Carrie Mae recommended Korine, as she had helped Carrie Mae for many years. I got a text from Holly saying that she was leaving her house and that she would see me soon. I had so much to share with her. I could only hope that one day she’d leave her husband and move to wine country, but knew I was dreaming.")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext2"
  }, [_c('span', {
    staticClass: "dedication1"
  }, [_vm._v("Alex called as I was carrying the rocking chair to the porch to start my business day.")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext2"
  }, [_c('span', {
    staticClass: "dedication1"
  }, [_vm._v("“How are your aching bones?” he asked in a teasing voice.")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext2"
  }, [_c('span', {
    staticClass: "dedication1"
  }, [_vm._v("“I still feel like I’m ninety years old, but I’m slowly getting better. Holly is coming out for lunch today.”")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext2"
  }, [_c('span', {
    staticClass: "dedication1"
  }, [_vm._v("“How did she manage that?”")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext2"
  }, [_c('span', {
    staticClass: "dedication1"
  }, [_vm._v("“Good question. She needs to borrow a couple of quilts, and I told her to come and get them.”")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext2"
  }, [_c('span', {
    staticClass: "dedication1"
  }, [_vm._v("“Why does she keep borrowing quilts from you when she can afford to buy any quilts she needs?”")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext2"
  }, [_c('span', {
    staticClass: "dedication1"
  }, [_vm._v("“What? Well, I’ll mention that. Speaking of work, are you keeping busy?”")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext2"
  }, [_c('span', {
    staticClass: "dedication1"
  }, [_vm._v("“Heavens to Betsy!” he exclaimed. “I’ll never catch up! Once a magazine likes something you’ve done, they book you with assignments like crazy.”")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext2"
  }, [_c('span', {
    staticClass: "dedication1"
  }, [_vm._v("“That’s great!”")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext2"
  }, [_c('span', {
    staticClass: "dedication1"
  }, [_vm._v("“The steady money is good. You really should put your education and talent to beneficial use, Lily Girl.”")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext2"
  }, [_c('span', {
    staticClass: "dedication1"
  }, [_vm._v("“I would love that, but as you know, my life has taken another turn.”")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext2"
  }, [_c('span', {
    staticClass: "dedication1"
  }, [_vm._v("“Maybe you could open only on the weekends and write during the week.”")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext2"
  }, [_c('span', {
    staticClass: "dedication1"
  }, [_vm._v("“You’re dreaming, but I suppose if I find that I can’t pay the bills, I may have to consider some kind of freelancing.”")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext2"
  }, [_c('span', {
    staticClass: "dedication1"
  }, [_vm._v("“Hey, Lynn invited me over for Thanksgiving, which I thought was sweet of her.”")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext2"
  }, [_c('span', {
    staticClass: "dedication1"
  }, [_vm._v("“Good! I was hoping she would.”")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext2"
  }, [_c('span', {
    staticClass: "dedication1"
  }, [_vm._v("“How was Halloween?” ")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext2"
  }, [_c('span', {
    staticClass: "dedication1"
  }, [_vm._v("I chuckled. “It was quite an experience. I guess you must be a mom to know all the characters, because I sure didn’t. What happened to just being a ghost or a witch?” ")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext2"
  }, [_c('span', {
    staticClass: "dedication1"
  }, [_vm._v("He laughed. “I keep my porch lights off on Halloween. I worry a bit in this neighborhood about any tricks going on. Hey, I have to run, so you have a wonderful day!” ")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext2"
  }, [_c('span', {
    staticClass: "dedication1"
  }, [_vm._v("It was an abrupt ending to our conversation, but Alex was my very best friend. We used to work together at the same publishing house. He quit to pursue freelance writing and I continued to work there until I was burned out. I ended my job there without finding another, and now I’m a shop owner in the small town of Augusta. Who could have seen that coming? ")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext2"
  }, [_c('span', {
    staticClass: "dedication1"
  }, [_vm._v("A man came in holding several quilts in his arms. It certainly got my attention. ")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext2"
  }, [_c('span', {
    staticClass: "dedication1"
  }, [_vm._v("“Good morning,” I said.")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext2"
  }, [_c('span', {
    staticClass: "dedication1"
  }, [_vm._v("“Boy, I’m glad you’re open,” he said as he smiled. “I have these quilts I want to sell, and I heard you know a lot about them and might resell them.”")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext2"
  }, [_c('span', {
    staticClass: "dedication1"
  }, [_vm._v("“Yes, I do like quilts. What’s the story here? Are you a dealer?”")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext2"
  }, [_c('span', {
    staticClass: "dedication1"
  }, [_vm._v("“Oh, no,” he chuckled as he shook his head. “I’m getting divorced and I want to get rid of these.”")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext2"
  }, [_c('span', {
    staticClass: "dedication1"
  }, [_vm._v("“It appears that these are quite new. I’m in the antique business, so I only sell old quilts.” ")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext2"
  }, [_c('span', {
    staticClass: "dedication1"
  }, [_vm._v("He looked perplexed. “Well, we’ve had these quilts for a long time.”")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext2"
  }, [_c('span', {
    staticClass: "dedication1"
  }, [_vm._v("“Who made these? They are quite beautiful.” ")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext2"
  }, [_c('span', {
    staticClass: "dedication1"
  }, [_vm._v("“Look, I’ll take whatever you offer me,” he said, ignoring my question.")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext2"
  }, [_c('span', {
    staticClass: "dedication1"
  }, [_vm._v("“I’m sorry, but I’d bet that other family members would love to have some of this work from the quiltmaker. You can also donate them to worthy charities who could auction them off. I must decline. I’m sorry. They are lovely, but they are not what I sell.” ")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext2"
  }, [_c('span', {
    staticClass: "dedication1"
  }, [_vm._v("He looked angry as he gathered them up and prepared to leave. “I don’t know how you can call yourself a quilt shop when you don’t carry all kinds of quilts,” he said angrily. ")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext2"
  }, [_c('span', {
    staticClass: "dedication1"
  }, [_vm._v("I shrugged my shoulders and tried to smile.")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext2"
  }, [_c('span', {
    staticClass: "dedication1"
  }, [_vm._v("After he left, I had to snicker a bit to myself. Who and what do folks think I’m supposed to be? I had to assume that the quilts were probably made by his wife, and he wanted cash for them as a way of getting back at her. I wondered if she knew what he was up to.")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext2"
  }, [_c('span', {
    staticClass: "dedication1"
  }, [_vm._v("Holly arrived around noon. She was chatty and appeared nervous. “I forgot how long it takes to get out here,” she said, putting down the lunch bag.")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext2"
  }, [_c('span', {
    staticClass: "dedication1"
  }, [_vm._v("“The monster was asleep, I presume?”")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext2"
  }, [_c('span', {
    staticClass: "dedication1"
  }, [_vm._v("“Yes, and when he gets up, he’ll call me, so I have my phone turned off,” she explained. “Let’s eat. I’m starving.”")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext2"
  }, [_c('span', {
    staticClass: "dedication1"
  }, [_vm._v("“Let’s go in here and sit down. Try to relax, Holly. He is far away.”")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext2"
  }, [_c('span', {
    staticClass: "dedication1"
  }, [_vm._v("“You don’t look like you were in an accident,” she said, looking me over. ")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext2"
  }, [_c('span', {
    staticClass: "dedication1"
  }, [_vm._v("I smiled. “My injuries were all internal. I’m still moving slowly. Hey, check out the porch, will you?”")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext2"
  }, [_c('span', {
    staticClass: "dedication1"
  }, [_vm._v("“What a change! It will be lovely out here. You’ll need some plants.”")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext2"
  }, [_c('span', {
    staticClass: "dedication1"
  }, [_vm._v("“Yes, I know. I have some furniture coming for both porches. The upstairs porch will be private, so I chose a couch I can sleep on if I choose to. This one will likely have garden merchandise for sale on it. I can’t wait to fill it up, but I want a table and chairs, so I can sit and be able to socialize as well.”")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext2"
  }, [_c('span', {
    staticClass: "dedication1"
  }, [_vm._v("“Oh, I envy you! I can’t wait to look around and shop. I need to start my Christmas shopping.”")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext2"
  }, [_c('span', {
    staticClass: "dedication1"
  }, [_vm._v("“Great idea, but let’s eat first.”")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext2"
  }, [_c('span', {
    staticClass: "dedication1"
  }, [_vm._v("We dove into our soup and sandwiches as we chatted away. She always had such funny stories, despite her stressful life with Maurice. I think her sense of humor helped her deal with her life’s circumstances. We were interrupted when someone came in looking for antique canes. Since I had none, that customer didn’t stay very long. After lunch, we pulled out the quilts Holly had inquired about. She was excited when she saw some quilts she hadn’t seen before.")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext2"
  }, [_c('span', {
    staticClass: "dedication1"
  }, [_vm._v("“If you plan on doing this lecture more than once, you really ought to consider purchasing them. I’d give you a fair price.”")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext2"
  }, [_c('span', {
    staticClass: "dedication1"
  }, [_vm._v("“You’re right. If I get this blue-and-white Drunkard’s Path, will you give me a decent price on that as well?” ")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext2"
  }, [_c('span', {
    staticClass: "dedication1"
  }, [_vm._v("I laughed and nodded. Holly was known as the “Queen of Free” among those who knew her well. “By the way, I was invited to visit a small quilting group at the library here in town.” ")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext2"
  }, [_c('span', {
    staticClass: "dedication1"
  }, [_vm._v("Holly looked at me, surprised. “Are you seriously thinking of learning to quilt?” ")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext2"
  }, [_c('span', {
    staticClass: "dedication1"
  }, [_vm._v("“I don’t know, but they could be potential customers, and I need to meet more people here.”")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext2"
  }, [_c('span', {
    staticClass: "dedication1"
  }, [_vm._v("“You visiting a quilting group is something I would like to see,” she teased. ")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext2"
  }, [_c('span', {
    staticClass: "dedication1"
  }, [_vm._v("I noticed that Holly was glancing at her watch. “It’s early,” I reminded her.")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext2"
  }, [_c('span', {
    staticClass: "dedication1"
  }, [_vm._v("At three, she brought a glass pitcher to the counter to buy with her quilts and said she needed to leave. I thanked her for lunch and her many purchases. ")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext2"
  }, [_c('span', {
    staticClass: "dedication1"
  }, [_vm._v("“This was so fun, Lily. I miss you. I hate it that we are so far away from each other.”")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext2"
  }, [_c('span', {
    staticClass: "dedication1"
  }, [_vm._v("I helped carry her purchases to the car, and we hugged. I was still unused to saying goodbye to those I loved. ")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext2"
  }, [_c('span', {
    staticClass: "dedication1"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "basic-text-frame"
  }, [_c('p', {
    staticClass: "bodytext"
  }, [_c('span', {
    staticClass: "testimonial-body"
  })]), _vm._v(" "), _c('p', {
    staticClass: "bodytext1"
  }, [_c('span', {
    staticClass: "testimonial-body"
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-10a6b53f","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/Lily_Girl_split9.vue
// module id = 87
// module chunks = 0